import type { QueryClient } from '@tanstack/react-query';

/**
 * Cancel all in-flight react-query queries.
 * Called on session expiry (isSessionExpired false→true) to physically stop
 * ongoing requests — complementing the api.ts interceptor's request-time guard.
 */
export function cancelAllGuardedQueries(queryClient: QueryClient): void {
  try {
    queryClient.cancelQueries();
  } catch {
    // fail-safe: cancelQueries must never crash the app
  }
}
